import axios from 'axios';


export const getCompany=() =>{
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`department`);
}
export const getSites=() =>{
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`department/sites`);
}
export const AddCampany=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`department/create`, obj, {
    headers,
  });
}

export const EditCampany=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`department/update`, obj, {
    headers,
  });
}

export const DeleteCampany=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`department/delete`, obj, {
    headers,
  });
}